import { TOOLTIPS } from "./tooltips";

/**
 * The SSML Amazon Connect (through Polly) understands, as the quick-select
 * beside the announcement editor offers it. Each entry is the snippet
 * inserted at the cursor. Kept to the tags Connect's documentation lists
 * as supported in Play prompt and Get customer input blocks.
 */
export interface SsmlTag {
  tag: string;
  label: string;
  snippet: string;
  hint: string;
}

export const SSML_TAGS: SsmlTag[] = [
  { tag: "break", label: "Pause", snippet: '<break time="500ms"/>', hint: TOOLTIPS["ssml.pause"] },
  { tag: "emphasis", label: "Emphasis", snippet: '<emphasis level="moderate">word</emphasis>', hint: TOOLTIPS["ssml.emphasis"] },
  { tag: "prosody", label: "Rate / pitch / volume", snippet: '<prosody rate="slow" pitch="medium" volume="medium">text</prosody>', hint: TOOLTIPS["ssml.rate-pitch-volume"] },
  { tag: "say-as", label: "Say as", snippet: '<say-as interpret-as="telephone">18005550100</say-as>', hint: TOOLTIPS["ssml.say-as"] },
  { tag: "p", label: "Paragraph", snippet: "<p>sentence</p>", hint: TOOLTIPS["ssml.paragraph"] },
  { tag: "s", label: "Sentence", snippet: "<s>sentence</s>", hint: TOOLTIPS["ssml.sentence"] },
  { tag: "sub", label: "Substitute", snippet: '<sub alias="Amazon Web Services">AWS</sub>', hint: TOOLTIPS["ssml.substitute"] },
  { tag: "phoneme", label: "Pronounce", snippet: '<phoneme alphabet="ipa" ph="pɪˈkɑːn">pecan</phoneme>', hint: TOOLTIPS["ssml.pronounce"] },
  { tag: "lang", label: "Language", snippet: '<lang xml:lang="fr-FR">Bonjour</lang>', hint: TOOLTIPS["ssml.language"] },
  { tag: "w", label: "Word role", snippet: '<w role="amazon:VB">read</w>', hint: TOOLTIPS["ssml.word-role"] },
  { tag: "amazon:effect", label: "Whisper / soft", snippet: '<amazon:effect name="whispered">text</amazon:effect>', hint: TOOLTIPS["ssml.whisper"] },
  { tag: "amazon:domain", label: "News / conversational", snippet: '<amazon:domain name="conversational">text</amazon:domain>', hint: TOOLTIPS["ssml.speaking-style"] },
];

export const isSsml = (text: string): boolean => /^\s*<speak[\s>]/.test(text);

/** Wraps in `<speak>` once; removing the wrapper leaves the inner text. */
export const toSsml = (text: string): string => (isSsml(text) ? text : `<speak>${text}</speak>`);
export const fromSsml = (text: string): string => text.replace(/^\s*<speak[^>]*>/, "").replace(/<\/speak>\s*$/, "");
